/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../api/index';
import * as core from '../../../../core';
import * as serializers from '../../../index';

export const DidCommMessageSignRequestDidMethod: core.serialization.Schema<
    serializers.DidCommMessageSignRequestDidMethod.Raw,
    Truvity.DidCommMessageSignRequestDidMethod
> = core.serialization.enum_(['key', 'web']);

export declare namespace DidCommMessageSignRequestDidMethod {
    export type Raw = 'key' | 'web';
}
